import React from 'react';
import BMPSelectionInfo from './infoSections/BMPSelectionInfo';
import BMPSelectionControls from './selectionControls/BMPSelectionControls';
import BMPSiteInformationTable from './selectionControls/BMPSiteInformationTable';

export default function BMPSelectionTab() {
  return (
    <>
      <BMPSelectionInfo />
      <BMPSelectionControls />
      <BMPSiteInformationTable />
    </>
  );
}
